"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlurStrengthMapper = void 0;
/**
 * The numbers below indicate the amount of blur to apply. Larger numbers will produce
 * more blur.
 */

var BlurStrength = {
  LOW: 7,
  MEDIUM: 15,
  HIGH: 30
};
/** @internal */

var BlurStrengthMapper = /*#__PURE__*/function () {
  function BlurStrengthMapper() {
    _classCallCheck(this, BlurStrengthMapper);
  }

  _createClass(BlurStrengthMapper, null, [{
    key: "getBlurAmount",
    value: function getBlurAmount(bstrength, options) {
      if (bstrength <= 0) {
        throw new Error("invalid value for blur strength: ".concat(bstrength));
      }

      return Math.round(bstrength * options.height / this.BLUR_STRENGTH_DIVISOR);
    }
  }]);

  return BlurStrengthMapper;
}();

exports.BlurStrengthMapper = BlurStrengthMapper;
BlurStrengthMapper.BLUR_STRENGTH_DIVISOR = 540; // use 540P as baseline blur strength

exports.default = BlurStrength;